export default class ApiConfig {
	apiLanguage() {
		if (!this.language) {
			this.language = document.documentElement.dataset.apilanguage;
		}

		return this.language;
	}

	apiNode() {
		if (!this.node) {
			this.node = document.documentElement.dataset.apinode;
		}

		return this.node;
	}
}
